module.exports = __webpack_public_path__ + "static/media/015_Fox_Pro_Plantacao.c6f2ae75.mp4";